/**
 * @generated SignedSource<<c14e87c6a5c8d064e6865c1808c6572b>>
 * @relayHash 98ac0db350bb8c8dd9706e193c50dad9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5aae8cdb77fefc33d2854b7ff3153441b2a076543f6f377bf8d6bda4d945c5ac

import type { ConcreteRequest } from 'relay-runtime';
export type InitialPermissionOptions = "COPY_FROM_SPACE" | "DEFAULT" | "PRIVATE" | "%future added value";
export type useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$variables = {
  copySpacePermissionsFromSpaceKey?: string | null;
  initialPermissionOption?: InitialPermissionOptions | null;
  name: string;
};
export type useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$data = {
  readonly createPersonalSpace: {
    readonly homepageId: string | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null;
};
export type useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation = {
  response: useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$data;
  variables: useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "copySpacePermissionsFromSpaceKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "initialPermissionOption"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "copySpacePermissionsFromSpaceKey",
            "variableName": "copySpacePermissionsFromSpaceKey"
          },
          {
            "kind": "Variable",
            "name": "initialPermissionOption",
            "variableName": "initialPermissionOption"
          },
          {
            "kind": "Variable",
            "name": "spaceName",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "createPersonalSpace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "homepageId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "98ac0db350bb8c8dd9706e193c50dad9",
    "id": "5aae8cdb77fefc33d2854b7ff3153441b2a076543f6f377bf8d6bda4d945c5ac",
    "metadata": {},
    "name": "useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation($name:String!,$initialPermissionOption:InitialPermissionOptions,$copySpacePermissionsFromSpaceKey:String){createPersonalSpace(input:{spaceName:$name,initialPermissionOption:$initialPermissionOption,copySpacePermissionsFromSpaceKey:$copySpacePermissionsFromSpaceKey}){id,key,name,icon{path},homepageId}}"
  }
};
})();

(node as any).hash = "f5230085dddd4a6aaddfaffc37105490";

export default node;
